'use strict';

/**
 * Allows user to scroll an element with the mouse in desktop
 */
function enableDesktopMouseScroll() {
    var slider = $('.desktop-mouse-scroll');
    var isDown = false;
    var startX;
    var scrollLeftM;
    var targetSlider;
    slider.on('mousedown', function (e) {
        isDown = true;
        startX = e.pageX;
        targetSlider = $(this);
        scrollLeftM = targetSlider.scrollLeft();
    });

    $('body').on('mouseleave mouseup', function () {
        isDown = false;
    });

    $('body').on('mousemove', function (e) {
        if (!isDown) return;
        e.preventDefault();
        var x = e.pageX;
        var walk = x - startX;
        targetSlider.scrollLeft(scrollLeftM - walk);
    });
}

enableDesktopMouseScroll();
